import { cusAxios, PREFIX } from "./main";
import axios from "axios";

const loginTelegram = async (data) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/login_telegram`,
    data: { ...data }
  });
  return response;
};

const loginPhone = async ({ phone, password, captcha, currency, start_r, pb_params }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/login_phone`,
    data: { phone, password, captcha, currency, start_r, pb_params }
  });
  return response;
};

const loginEmail = async (data) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/login_email`,
    data: { ...data }
  });
  return response;
};

const userBalance = async (data) => {
  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/user_balance`,
    data: { ...data }
  });
  return response;
};

const balance = async () => {
  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/user_all_balances`
  });
  return response;
};

const balanceDetail = async ({ currency }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/balance_detail`,
    data: { currency }
  });
  return response;
};

const changePassword = async (data) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/change_password`,
    data: { ...data }
  });
  return response;
};

const changeEmail = async (data) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/change_email`,
    data: { ...data }
  });
  return response;
};

const repeatVerifyCode = async () => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/verify_email`
  });
  return response;
};

const logout = async (data) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/logout`,
    data: { ...data }
  });
  return response;
};
const depositLimit = async (data) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/deposit_limit`,
    data: { ...data }
  });
  return response;
};
const getDepositLockInfo = async () => {
  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/deposit_lock_info`
  });
  return response;
};
const depositMethod = async ({ amount, currency }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/deposit_method`,
    data: { amount, currency }
  });
  return response;
};
const getCryptoMethod = async ({ currency }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/cryptogate_wallet`,
    data: { currency }
  });
  return response;
};
const getCryptogateAddress = async ({ currency, wallet, captcha }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/cryptogate_address`,
    data: { currency, wallet, captcha }
  });
  return response;
};

const makeDeposit = async ({ amount, currency, method, captcha }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/make_deposit`,
    data: { amount, currency, method, captcha }
  });
  return response;
};

const getCryptoAddress = async (data) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/get_address`,
    data: { ...data }
  });
  return response;
};

const changeCurrency = async (data) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/change_currency`,
    data: { ...data }
  });
  return response;
};

const payoutInfo = async () => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/payout_info`
  });
  return response;
};

const promocode = async (data) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/use_promocode`,
    data: { ...data }
  });
  return response;
};

const makePayout = async (data) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/make_payout`,
    data: { ...data }
  });
  return response;
};

const toggleFavorites = async (gameId) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/toggle_favorites`,
    data: { gameId }
  });
  return response;
};
const clearBonus = async () => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/clear_bonus`
  });
  return response;
};
const resetPas = async ({ email, captcha }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/reset_password`,
    data: { email, captcha }
  });
  return response;
};
const newPas = async ({ code }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/new_password`,
    data: { code }
  });
  return response;
};

const confirmEmail = async ({ code }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/confirm_email`,
    data: { code }
  });
  return response;
};

const getProfile = async () => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/user_profile`
  });
  return response;
};

const depositList = async ({ currency }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/user_deposit_list`,
    data: { currency }
  });
  return response;
};

const payoutList = async ({ currency }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/user_payout_list`,
    data: { currency }
  });
  return response;
};

const userPayoutInfo = async ({ invoiceId }) => {
  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/user_payout_info`,
    data: { invoiceId }
  });
  return response;
};

export const API_USER = {
  login: {
    telegram: loginTelegram,
    email: loginEmail,
    phone: loginPhone
  },
  logout,
  balance: {
    info: balance,
    userBalance: userBalance,
    detail: balanceDetail,
    limit: depositLimit,
    replenish: makeDeposit,
    getCryptoAddress,
    method: depositMethod,
    getCryptoMethod,
    getCryptogateAddress,
    getDepositLockInfo,
    depositList,
    payoutList,
    userPayoutInfo,
    payout: {
      info: payoutInfo,
      make: makePayout
    },
    clearBonus: clearBonus
  },
  getProfile,
  changeCurrency,
  changePassword,
  changeEmail,
  toggleFavorites,
  resetPas,
  newPas,
  confirmEmail,
  repeatVerifyCode,
  promocode
};
